'use client'
import { useState } from 'react'
import { usePathname } from 'next/navigation'
import { TorContext } from 'utils/context'
import { torsCats } from 'config/const'

const TorLayout = ({ children }) => {
  const [tor, setTor] = useState()
  const pathname = usePathname()
  const torDetails = torsCats.find(({ torUrl }) => pathname.includes(torUrl))

  return (
    <TorContext.Provider value={{ tor, setTor, torDetails }}>
      {children}
    </TorContext.Provider>
  )
}

export default TorLayout
